import { FormEvent, useState } from 'react'
import Button from '@/shared/Buttons/Button'
import Checkbox from '@/shared/Inputs/Checkbox'
import TextInput from '@/shared/Inputs/TextInput'
import Form from '@/shared/Forms/Form'
import FormField from '@/shared/Forms/FormField'
import authApi from './auth.api'
import { AuthSessionCtrl } from './useAuthSession'
import css from './authPage.module.css'

interface IProps {
  auth: AuthSessionCtrl
}

const AuthPage = ({ auth }: IProps) => {
  const [form, setForm] = useState({ login: '', password: '', rememberMe: true })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleChange = (value: string | boolean, name: string) => {
    setError('')
    setForm((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (_ev: FormEvent) => {
    setLoading(true)
    const response = await authApi.login({ login: form.login.trim(), password: form.password })
    setLoading(false)

    if (response.status === 'error') {
      setError(response.message)
      return
    }

    auth.setSession(
      {
        accessToken: response.body.auth.accessToken,
        expires: response.body.auth.expires,
        user: response.body.user,
      },
      form.rememberMe
    )
  }

  if (auth.checkingSession) {
    return (
      <div className="flex-lines center height100" style={{ minHeight: '100vh' }}>
        <p className="text-nm text-description">Проверка сессии</p>
      </div>
    )
  }

  return (
    <div className={css.page}>
      <section className={css.panel}>
        <div className={css.brand}>
          <div className={css.brandMark}>VK</div>
          <div>
            <h1 className="text-heading-4">Панель управления сайтом</h1>
          </div>
        </div>

        <Form className={css.form} onSubmit={handleSubmit}>
          <FormField label="Логин" required>
            <TextInput
              value={form.login}
              name="login"
              onChange={handleChange}
              placeHolder="admin"
              size="large"
              disabled={loading}
            />
          </FormField>
          <FormField label="Пароль" required>
            <TextInput
              value={form.password}
              name="password"
              onChange={handleChange}
              placeHolder="Пароль"
              type="password"
              size="large"
              disabled={loading}
              error={Boolean(error)}
              inscription={error}
            />
          </FormField>
          <Checkbox
            label="Запомнить меня"
            checked={form.rememberMe}
            name="rememberMe"
            onCheck={handleChange}
          />
          <Button
            buttonType="submit"
            type="primary"
            size="large"
            text="Войти"
            fullWidth
            loading={loading}
            disabled={!form.login || !form.password}
          />
        </Form>
      </section>
      <section className={css.visual} aria-hidden="true">
        <div className={css.visualCanvas}>
          <div className={css.browserFrame}>
            <div className={css.browserTopbar}>
              <span />
              <span />
              <span />
            </div>
            <div className={css.dashboardMock}>
              <div className={css.mockSidebar}>
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <div className={css.mockContent}>
                <div className={css.heroPreview}>
                  <div />
                  <div />
                  <div />
                </div>
                <div className={css.metricsRow}>
                  <span />
                  <span />
                  <span />
                </div>
                <div className={css.visualGrid}>
                  <div className={css.mediaMosaic}>
                    <span />
                    <span />
                    <span />
                    <span />
                  </div>
                  <div className={css.chartPanel}>
                    <span />
                    <span />
                    <span />
                    <span />
                    <span />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={css.floatingCard}>
            <span />
            <span />
            <span />
          </div>
          <div className={css.assetStack}>
            <span />
            <span />
            <span />
            <span />
          </div>
        </div>
      </section>
    </div>
  )
}

export default AuthPage
